import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board4 from '../images/board4.jpg'

export function A04({ index }) {
  return (
    <Article
      index={index}
      heading="The app is instantly global."
      image={board4}
      imageDescription="The app is being used in every corner of the globe!"
    >
      <div className="article-row">
        <p>
          Once CanCan is on the Internet Computer, it exists anywhere that
          people can access the internet around the world. The app's users have
          a good experience wherever they are located because each of the
          Internet Computer's nodes is always synchronized with the rest of the
          network, meaning that CanCan has effectively launched everywhere
          without ancillary services like content delivery networks and
          databases.
          <br />
          <br />
          Scaling is therefore much easier than it would be with conventional,
          centralized compute apps. Since CanCan exists throughout the Internet
          Computer, the app cannot be “turned off” by any one cloud provider or
          local internet provider.
        </p>
      </div>
    </Article>
  )
}

A04.propTypes = {
  index: PropTypes.number.isRequired,
}
